// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3ekaV","title":"BackImages_title__3mUqG","images":"BackImages_images__1hNeY"};